import { Languages, RoutesEnum } from '~/constants/enums';
import {
  SavedPropertyItemType,
  SavedPropertyListingType,
} from '~/types/activitiesTypes';

export const getSavedPropertyNote = (item: SavedPropertyItemType) =>
  item.note || item.body || '';

export const getSavedPropertyListingRoute = (
  listing: SavedPropertyListingType,
  locale: string,
) =>
  `${process.env.REACT_APP_BASE_URL}/${locale}/${RoutesEnum.LISTING}/${
    listing.id
  }-${listing.slug || listing.section.slug}`;

export const getSavedPropertyImage = (listing: SavedPropertyListingType) => {
  const primaryPhoto = listing.photos?.[0];

  return primaryPhoto?.thumbnails?.thumb;
};

export const getSavedPropertyAddress = (listing: SavedPropertyListingType) => {
  if (listing.address) return listing.address;
  if (listing.location?.name) return listing.location.name;
  if (listing.location?.title) return listing.location.title;
  if (!listing.location?.title_full_path) return '';

  const locationTitlesArray = listing.location.title_full_path
    .split('/')
    .filter(Boolean);

  return locationTitlesArray.join(' / ');
};

export const getSavedPropertyCardAttributes = (
  listing: SavedPropertyListingType,
) => ({
  area: listing.area || 0,
  attributes: {
    rooms: listing.attributes?.rooms || null,
    baths: listing.attributes?.baths || null,
  },
});

export const hasContactedSavedProperty = (item: SavedPropertyItemType) =>
  Boolean(
    item.contacted ||
    item.is_contacted ||
    item.contacted_at ||
    item.listing?.isCallRequest ||
    item.listing?.is_call_request,
  );

export const getCompoundPropertyTypes = (
  listing: SavedPropertyListingType,
  locale: string,
) =>
  (listing.childrenPropertyTypes || []).join(
    locale === Languages.ARABIC ? '، ' : ', ',
  );
